import "./web.dom-collections.for-each-3020ed11.js";
import "./es.object.to-string-f55666a8.js";
var f = function() {
  for (var o = arguments.length, c = new Array(o), n = 0; n < o; n++)
    c[n] = arguments[n];
  return function(i) {
    c.forEach(function(t) {
      typeof t == "function" ? t(i) : t && typeof t == "object" && (t.current = i);
    });
  };
};
export {
  f as c
};
